<template>
  <section id="about" class="section-padding ethos-section">
            <div class="container ethos-section-content">
                
                <!-- Image Placeholder -->
                <div class="ethos-image-wrapper">
                    <img src="https://placehold.co/600x400/5D0E1F/f5f5f4?text=Afro-Chic+Ethos" alt="Salon Interior/Staff" class="ethos-image">
                </div>

                <!-- Text Content -->
                <div class="ethos-text-content">
                    <h2 class="title-serif">Where Culture Meets Couture</h2>
                    <p>
                        **The Hair Salon** is more than just a salon; it's a sanctuary built on the principle of Afro-chic elegance. We believe that caring for textured hair is an art form rooted in heritage and celebrated with modern flair. Our commitment is to use the highest quality, natural ingredients while delivering sophisticated, contemporary styles.
                    </p>
                    <p class="ethos-quote">
                        "Elegance and health are not mutually exclusive. We nurture the hair, and the confidence follows."
                    </p>
                    <a href="#" class="ethos-link">
                        Meet Our Stylists
                        <i data-lucide="arrow-right"></i>
                    </a>
                </div>

            </div>
        </section>
</template>

<script>
export default {

}
</script>

<style>

 .container {
            max-width: 1280px; /* max-w-7xl */
            margin-left: auto;
            margin-right: auto;
            padding-left: 1rem;
            padding-right: 1rem;
        }

        .section-padding { 
            padding-top: 5rem; /* py-20 !!!!!!!!!!!!!!!!!!!!! */
            padding-bottom: 5rem; /* py-20 */
        }

        .title-serif {
            font-family: var(--font-serif);
            font-weight: 700; /* bold */
        }


.ethos-section {
            background-color: #5D0E1F;
            color: white;
            display: flex;
            flex-direction: column;
            gap: 3rem;
        }
        @media (min-width: 1024px) {
            .ethos-section-content {
                display: flex;
                flex-direction: row;
                gap: 3rem;
                align-items: center;
            }
        }
        .ethos-image-wrapper {
            width: 100%;
        }
        @media (min-width: 1024px) {
            .ethos-image-wrapper { width: 50%; }
        }

        .ethos-image {
            border-radius: 40px;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
            width: 100%;
            height: auto;
            object-fit: cover;
            transform: rotate(1deg);
            transition: transform 0.5s;
        }
        .ethos-image:hover {
            transform: rotate(0deg);
        }

        .ethos-text-content {
            width: 100%;
        }
        @media (min-width: 1024px) {
            .ethos-text-content { width: 50%; }
        }

        .ethos-text-content h2 {
            font-size: 2.25rem; /* text-4xl */
            color: #FBBF24;
            margin-bottom: 1.5rem;
        }
        .ethos-text-content p {
            font-size: 1.125rem; /* text-lg */
            margin-bottom: 1.5rem;
        }
        .ethos-quote {
            font-style: italic;
            border-left: 4px solid #FBBF24;
            padding-left: 1rem;
            margin-bottom: 2rem;
            line-height: 1.75rem;
        }
        .ethos-link {
            display: inline-flex;
            align-items: center;
            font-weight: 700;
            color: #f5f5f4;
        }
        .ethos-link:hover {
            color: #FBBF24;
        }
        .ethos-link i {
            margin-left: 0.5rem;
        }
</style>